import BsSearch from './index.vue'
export default BsSearch